import { Button } from '../../../shared/components/Button';
import { ButtonsGroup } from '../../../shared/components/ButtonsGroup';
import { OllieFloating } from '../../../shared/components/OllieFloating';
import { SpeechBubble } from '../../../shared/components/SpeechBubble';

interface DrawAHeartIntroProps {
    onContinue: () => void;
    isDisabled: boolean;
    onSpeechBubbleComplete: () => void;
}

export const DrawAHeartIntro = ({ onContinue, isDisabled, onSpeechBubbleComplete }: DrawAHeartIntroProps) => {
    return (
        <div className='flex flex-col gap-10 safe-pb-4 px-8 flex-1 overflow-hidden'>
            <title>Extra Courage?</title>
            <div className='flex-1 flex flex-col justify-center items-center'>
                <div className='flex flex-col items-center justify-end overflow-show h-[250px]'>
                    <SpeechBubble
                        text="Thanks for sharing your goals. I'm Ollie, here to help you achieve them."
                        onTypingComplete={onSpeechBubbleComplete}
                    />
                    <OllieFloating />
                </div>
            </div>
            <div className="flex flex-col items-center justify-end gap-4 flex-shrink-0 relative z-10 min-h-[260px]">
                <div className="w-full flex flex-col justify-end">
                </div>
                <ButtonsGroup animated={false}>
                    <Button
                        inactive={isDisabled}
                        onClick={onContinue}
                        label="Tell me more"
                    />
                </ButtonsGroup>
            </div>
        </div>
    );
};
